// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5b8b4a13-567":"af291999ae64729036bd","5b8b4a13-452":"5af3bd77071448646329","5b8b4a13-812":"965501385383fb86e19b","5b8b4a13-83":"ac91d77b8f5854a68c2d"}[chunkId] + ".js";
};